export const CardHeader = (title: string) => {
    return (
        <h2
            style={{
                border: "none",
                marginLeft: "0",
                whiteSpace: "nowrap"
            }}
        >
            {title}
        </h2>
    )
}